export const MODEL_UPDATE_BOARD_ORDER = 'MODEL_UPDATE_BOARD_ORDER';
export const MODEL_UPDATE_COLUMN_ORDER = 'MODEL_UPDATE_COLUMN_ORDER';
export const MODEL_UPDATE_TASK_ORDER = 'MODEL_UPDATE_TASK_ORDER';
export const MODEL_UPDATE_TASK_ORDER_WITH_COLUMN = 'MODEL_UPDATE_TASK_ORDER_WITH_COLUMN';
